import { useEffect, useState } from "react";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";

export interface SapCodeEditPopupProps {
    isOpen: boolean;
    initialValue: string | undefined;
    onSave: (value: string) => void;
    onClose: () => void;
}

const sapCodeSchema = Yup.string().nullable().max(8);

export function useSapCodeEditPopup(props: SapCodeEditPopupProps) {
    const { t } = useTranslation();
    const [localValue, setLocalValue] = useState(props.initialValue ?? "");

    useEffect(() => {
        if (props.isOpen) {
            setLocalValue(props.initialValue ?? "");
        }
    }, [props.isOpen, props.initialValue]);

    const isValid = sapCodeSchema.isValidSync(localValue);

    function handleChange(value: string) {
        setLocalValue(value);
    }

    function handleSave() {
        if (!isValid) return;
        props.onSave(localValue);
        props.onClose();
    }

    return {
        state: {
            localValue,
            isValid,
        },
        handlers: {
            handleChange,
            handleSave,
        },
        utilities: {
            validationMessage: !isValid ? t("RECIPES_VALIDATION_SapCodeMax") : undefined,
        },
    };
}
